<div class="panel-options-heading">
    <ng-content></ng-content>

    <div class="close-btn" (click)="closePanel()">×</div>
</div>
